var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-avatar',{class:{
    avatar: _vm.extra_avatar_class,
    'user-details-avatar': !_vm.extra_avatar_class
  },attrs:{"size":_vm.$vuetify.breakpoint.mdAndDown ? _vm.mobile_size : _vm.desktop_size,"color":"primary"}},[(_vm.avatar_uri)?_c('v-img',{attrs:{"src":_vm.avatar_uri ? _vm.avatar_uri : ''}}):_c('span',{staticClass:"base-section-title white--text"},[_vm._v(" "+_vm._s(_vm.get_name_initials(_vm.name))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }